
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import {TableHeaderItem} from "@/views/components/YtoTable/TableHeaderItem";
  import {parseTime} from "@/utils";
  import DataEmpty from "@/views/components/DataEmpty/DataEmpty.vue";

  @Component({
    name: "YtoTableWithFullHeight",
    components: {DataEmpty},
    filters: {
      parseValue(value: any, prop: string) {
        if (value instanceof Date) {
          return parseTime(value);
        }
        //console.log(`${prop}--${typeof value}`);
        return value;
      }
    }
  })

  export default class extends Vue {
    @Prop({default: []}) private tableHeaders!: TableHeaderItem[];
    @Prop() private data;

    @Watch('currentRow', {deep: false})
    oncurrentRowChanged(val: string, oldVal: string) {
      this.$emit("currentRowChanged", val);
    }

    private currentRow = null;

    //上传成功,为黑色，其他都是红色
    private rowClassAction(row) {
      if (/失败/.test(row.row.UploadStateName) || /失败/.test(row.row.state)) {
        return {color: "#f22613", "font-size": "130%", "font-weight": "bold"};
      }
    }

    private handleCurrentChange(val) {
      if (val) {
        console.log("|FUNC|handleCurrentChange");
        console.log(val);
        var table = this.$refs.tttb;
        console.log(table);
        this.currentRow = val;
      }
    }

    private rowDbCLick(row, column, event) {
      console.log(row);
      this.$emit('dbclick', row, column, event)
    }

    public tableRowClassName({row, rowIndex}) {
      let self = this;
      for (let i = 0; i < self.data.length; i++) {
        if (self.currentRow === self.data[i]) {
          return 'select-row';
        }
      }
    }

    public getSelectRow() {
      return this.currentRow;
    }
  }
